import { AppRegistry, ModelRegistry } from 'core/registry';

export const globalConfig = {};
const toInit = [];
let configured = false;

export function onInit(func) {
  toInit.push(func);
}

function doInit() {
  // FIXME - replace with map
  // eslint-disable-next-line
  for (const key of Object.keys(toInit)) {
    toInit[key]();
  }
}

export function configure(conf) {
  if (configured) {
    return;
  }
  Object.assign(globalConfig, conf);
  AppRegistry.resolve();
  ModelRegistry.resolve();
  doInit();
  configured = true;
}
